import Axios from "axios";
import Firebase from "firebase";
import moment from "moment";
import store from "../store";
import i18n from "../i18n";

const TrainingInfoStore = {
  namespaced: true,
  debug: true,
  state: {
    trainingInfoList: [],
    trainingDetail: {},
    trainingMaster: {}
  },
  mutations: {
    setTrainingInfoList(state, data) {
      state.trainingInfoList = data;
    },
    setTrainingInfo(state, data) {
      state.trainingDetail = data;
    },
    setTrainingMaster(state, data) {
      state.trainingMaster = data;
    }
  },
  getters: {
    getTrainingInfoList(state) {
      return state.trainingInfoList.map(val => {
        let result = {
          schedulenumber: val.schedulenumber,
          day: moment(val.startdate).format("YYYY/MM/DD"),
          startTime:
            moment(val.startdate).format("Ah:mm ") +
            i18n.t("page.reservationCommon.start"),
          endTime:
            moment(val.enddate).format("Ah:mm ") +
            i18n.t("page.reservationCommon.end"),
          type:
            val.type != null && val.type != ""
              ? store.getters[
                  "constantStore/constant/constantStore/getTypeData"
                ](val.type).label
              : "",
          status: val.Status,
          capacity: val.capacity,
          noReservation: val.noreservation,
          reservationcount: val.reservationcount
        };
        if (val.status == "Reserved") {
          result.status = i18n.t("page.reservationCommon.reserved");
          result.color = "yellow";
          result.disable = true;
          result.dark = true;
        } else if (
          result.capacity <= result.reservationcount ||
          moment().isAfter(
            moment(val.startdate).subtract(
              parseFloat(process.env.VUE_APP_CLOSING_TIME),
              "hours"
            )
          )
        ) {
          result.status = i18n.t("page.reservationCommon.notAvailable");
          result.color = "grey";
          result.disable = true;
          result.dark = false;
        } else {
          result.status = i18n.t("page.reservationCommon.available");
          result.color = "red";
          result.disable = false;
          result.dark = true;
        }
        return result;
      });
    },
    getTrainingInfoDetail(state) {
      let result = {
        schedulenumber: state.trainingDetail.schedulenumber,
        day: moment(state.trainingDetail.startdate).format("YYYY/MM/DD"),
        targetDate: moment(state.trainingDetail.targetdate),
        startTime: moment(state.trainingDetail.startdate).format("Ah:mm"),
        endTime: moment(state.trainingDetail.enddate).format("Ah:mm"),
        type:
          state.trainingDetail.type != null && state.trainingDetail.type != ""
            ? store.getters["constantStore/constant/constantStore/getTypeData"](
                state.trainingDetail.type
              ).label
            : "",
        content: state.trainingDetail.content,
        content2: state.trainingDetail.content2,
        noReservation: state.trainingDetail.noreservation,
        buttonShow: false
      };
      if (state.trainingDetail.status === "NotReserved") {
        if (
          state.trainingDetail.reservationcount <
            state.trainingDetail.capacity &&
          moment().isBefore(
            moment(state.trainingDetail.startdate).subtract(
              parseFloat(process.env.VUE_APP_CLOSING_TIME),
              "hours"
            )
          )
        ) {
          result.buttonShow = true;
          result.status = i18n.t("page.reservationCommon.available");
          result.buttonColor = "red";
          result.buttonType = "reserve";
        } else {
          result.status = i18n.t("page.reservationCommon.notAvailable");
        }
      } else {
        if (
          state.trainingDetail.status === "Reserved" &&
          moment().isBefore(
            moment(state.trainingDetail.startdate).subtract(
              parseFloat(process.env.VUE_APP_CLOSING_CANCEL_TIME),
              "hours"
            )
          )
        ) {
          result.buttonShow = true;
          result.status = i18n.t("page.reservationCommon.reserved");
          result.buttonColor = "grey";
          result.buttonType = "cancel";
        } else {
          result.status = i18n.t("page.reservationCommon.used");
        }
      }
      return result;
    },
    getTrainingMaster(state) {
      return state.trainingMaster;
    }
  },
  actions: {
    async callApiTrainingDetail({ commit }, scheduleNumber) {
      await Firebase.auth()
        .currentUser.getIdToken(true)
        .then(async function(idToken) {
          let bearerToken = "Bearer " + idToken;
          let trainingInfo = await Axios.post(
            process.env.VUE_APP_API_URL + "api/user/trainingDetail",
            {
              scheduleNumber: scheduleNumber
            },
            {
              headers: {
                Authorization: bearerToken
              }
            }
          );
          commit("setTrainingInfo", trainingInfo.data[0]);
        })
        .catch(function() {
          // Handle error
        });
    },
    async callApiTrainingList({ commit }, searchParam) {
      await Firebase.auth()
        .currentUser.getIdToken(true)
        .then(async function(idToken) {
          let bearerToken = "Bearer " + idToken;
          let trainingInfoList = await Axios.post(
            process.env.VUE_APP_API_URL + "api/user/trainingList",
            {
              searchDate: searchParam.searchDate,
              type: searchParam.type
            },
            {
              headers: {
                Authorization: bearerToken
              }
            }
          );
          commit("setTrainingInfoList", trainingInfoList.data);
        })
        .catch(function() {
          // Handle error
        });
    },
    async callApiTrainingMaster({ commit }, searchParam) {
      await Firebase.auth()
        .currentUser.getIdToken(true)
        .then(async function(idToken) {
          let bearerToken = "Bearer " + idToken;
          let trainingMaster = await Axios.post(
            process.env.VUE_APP_API_URL + "api/user/trainingMaster",
            {
              searchDate: searchParam.searchDate,
              type: searchParam.type
            },
            {
              headers: {
                Authorization: bearerToken
              }
            }
          );
          if (trainingMaster.data.length > 0) {
            commit("setTrainingMaster", trainingMaster.data[0]);
          } else {
            commit("setTrainingMaster", {});
          }
        })
        .catch(function() {
          // Handle error
        });
    }
  }
};
export default TrainingInfoStore;
